const REACT_APP_EMAIL_BASE_URL = process.env.REACT_APP_EMAIL_BASE_URL;

const postDataMain = async (maildata: any, mailuri: any) => {
  const response = await fetch(`${REACT_APP_EMAIL_BASE_URL}/${mailuri}`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify(maildata),
  });
  const result = await response.json();
  return result;
};

export default postDataMain;
